"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVGDisplay = function (_React$Component) {
  _inherits(SVGDisplay, _React$Component);

  function SVGDisplay() {
    _classCallCheck(this, SVGDisplay);

    return _possibleConstructorReturn(this, (SVGDisplay.__proto__ || Object.getPrototypeOf(SVGDisplay)).apply(this, arguments));
  }

  _createClass(SVGDisplay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.el) {
        this.el.insertAdjacentHTML("beforeend", this.props.data);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.data !== this.props.data;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.el) return;
      // clear out all DOM element children
      while (this.el.firstChild) {
        this.el.removeChild(this.el.firstChild);
      }
      this.el.insertAdjacentHTML("beforeend", this.props.data);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement("div", {
        ref: function ref(el) {
          _this2.el = el;
        }
      });
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return SVGDisplay;
}(_react2.default.Component);

SVGDisplay.MIMETYPE = "image/svg+xml";
var _default = SVGDisplay;
exports.default = _default;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(SVGDisplay, "SVGDisplay", "src/svg.js");
  reactHotLoader.register(_default, "default", "src/svg.js");
  leaveModule(module);
})();

;


//////////////////
// WEBPACK FOOTER
// ./~/@nteract/transforms/lib/svg.js
// module id = 226
// module chunks = 186292428941015